module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_3016.a6269708.png";